import auth from './auth'
import user from './user'
import forgotPwd from './forgotPwd'

export const authService = auth
export const userService = user
export const forgotPwdService = forgotPwd